import {darken, lighten} from '@mui/material/styles';

// Helper function to calculate the background color based on the mode and factor
const calculateBackgroundColor = (color, mode, factor) =>
	mode === 'dark' ? darken(color, factor) : lighten(color, factor);

export default calculateBackgroundColor;